import { IncidentSearchPeriod } from '@roadfootage/api-client'

/** What the /search page reads from and writes to its URL: /search?q=...&footage=1&period=week */
export interface SearchRouteState {
  q: string
  hasFootage: boolean
  period: IncidentSearchPeriod
}

type RouteQuery = Record<string, unknown>

const PERIOD_TO_PARAM: Partial<Record<IncidentSearchPeriod, string>> = {
  [IncidentSearchPeriod.PastWeek]: 'week',
  [IncidentSearchPeriod.PastMonth]: 'month',
  [IncidentSearchPeriod.PastYear]: 'year'
}

const PARAM_TO_PERIOD: Record<string, IncidentSearchPeriod> = Object.fromEntries(
  Object.entries(PERIOD_TO_PARAM).map(([period, param]) => [param, period])
) as Record<string, IncidentSearchPeriod>

// vue-router gives string | string[] | null per key; take the first value.
function firstString(value: unknown): string {
  const first = Array.isArray(value) ? value[0] : value
  return typeof first === 'string' ? first : ''
}

export function parseSearchQuery(query: RouteQuery): SearchRouteState {
  return {
    q: firstString(query.q).trim(),
    hasFootage: firstString(query.footage) === '1',
    period: PARAM_TO_PERIOD[firstString(query.period)] ?? IncidentSearchPeriod.Any
  }
}

/** Only non-default values are written, so the URL stays short and shareable. */
export function toSearchQuery(state: SearchRouteState): Record<string, string> {
  const query: Record<string, string> = {}
  const q = state.q.trim()
  if (q) query.q = q
  if (state.hasFootage) query.footage = '1'
  const period = PERIOD_TO_PARAM[state.period]
  if (period) query.period = period
  return query
}
